import React, { memo } from 'react';
import { Col, Form, Row } from 'antd';
import { useSelector } from 'react-redux';
import { translate } from '@components/i18n';
import { Input } from '@components/input';
import { balanceSelector } from '@redux/slices/balance';
import { FormItem } from '@styles/components/form';
import { formatMoney } from '@utils/money';

export const Balance: React.FC = memo(() => {
  const balanceState = useSelector(balanceSelector);
  const [form] = Form.useForm();

  const formState = {
    saldoTotalDisponivelCliente: balanceState.balance?.saldoTotalDisponivelCliente || 0,
    saldoRecomendadoDivisao: balanceState.balance?.saldoRecomendadoDivisao || 0
  }

  form.setFieldsValue(formState)

  return (
    <Form
      form={form}
      layout="vertical"
      wrapperCol={{ span: 24 }}
      initialValues={formState}
    >
      <Row style={{ gap: '0.5rem' }}>
        <Col xs={24} md={11}>
          <FormItem label={translate('forms.labels.availableBalance')}>
            <Input
              disabled
              value={formatMoney('R$', form.getFieldValue("saldoTotalDisponivelCliente"))}
            />
          </FormItem>
        </Col>
      </Row>
    </Form>
  );
});
